import {useMutation} from 'react-query';
import {addViolation} from '../../../services/violation';

interface IViolationpayload {
  reason: string;
  description: string;
  guid: string;
  object_type: string;
}
export default function useSetViolation(isFarm: boolean) {
  const {mutate: handleSetViolation} = useMutation({
    mutationFn: (payload: IViolationpayload) => {
      const command = {
        reporter_app: isFarm ? 'farm' : 'market',
        object_guid: payload.guid,
        object_type: payload.object_type,
        reason: payload.reason,
        description: payload.description,
      };
      return addViolation(command);
    },
  });

  return {handleSetViolation};
}
